function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.92,135.51l-3.57-6.65a4.94,4.94,0,0,0-4.51-2.6,31.23,31.23,0,0,1-3.49-.11,5,5,0,0,0-4.68,2.3l-4,6.43-20.41-12.66,4-6.46a5,5,0,0,0,0-5.2c-.29-.49-.58-1-.85-1.49s-.53-1-.77-1.54a5,5,0,0,0-4.33-2.92l-7.57-.23.75-24,7.54.24A4.94,4.94,0,0,0,121.5,78c.56-1,1.18-2,1.84-3a5,5,0,0,0,.34-5.2l-3.56-6.65L141.29,51.8l3.57,6.66a5,5,0,0,0,4.52,2.59,31.23,31.23,0,0,1,3.49.11,5,5,0,0,0,4.68-2.31l4-6.41L181.94,65.1l-4,6.42a5,5,0,0,0,0,5.22c.3.49.58,1,.85,1.5s.54,1,.78,1.55a5,5,0,0,0,4.31,2.91l7.57.24-.75,24-7.56-.24a5,5,0,0,0-4.51,2.63,31.14,31.14,0,0,1-1.83,3,5,5,0,0,0-.34,5.19l3.57,6.65Zm-8-10.25a6,6,0,0,1,5.28,3.12l3.09,5.78,19.42-10.42-3.1-5.77a6,6,0,0,1,.4-6.23,31.64,31.64,0,0,0,1.77-2.87,6,6,0,0,1,5.42-3.16l6.56.21.69-22-6.57-.2a6,6,0,0,1-5.18-3.49c-.24-.5-.49-1-.76-1.5s-.54-1-.82-1.45a6,6,0,0,1,0-6.27l3.45-5.57L161.85,53.81l-3.45,5.57a5.94,5.94,0,0,1-5.61,2.77,31.91,31.91,0,0,0-3.39-.1A6,6,0,0,1,144,58.93l-3.1-5.77L121.47,63.57l3.09,5.77a5.94,5.94,0,0,1-.4,6.24c-.64.93-1.24,1.9-1.78,2.88A5.89,5.89,0,0,1,117,81.6l-6.54-.2-.69,22,6.57.2a6,6,0,0,1,5.2,3.49c.24.5.49,1,.75,1.49s.54,1,.83,1.45a6,6,0,0,1,0,6.24l-3.48,5.61,18.72,11.61,3.46-5.58a6,6,0,0,1,5.62-2.77,29.29,29.29,0,0,0,3.38.11ZM150.13,113a19.36,19.36,0,1,1,17-28.49h0a19.35,19.35,0,0,1-17,28.49Zm-.06-37.71A18.36,18.36,0,1,0,166.28,85h0A18.39,18.39,0,0,0,150.07,75.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.17,345.52l-3.57-6.65a4.91,4.91,0,0,0-4.51-2.59,33.63,33.63,0,0,1-3.48-.12,5,5,0,0,0-4.69,2.3l-4,6.43-20.41-12.66,4-6.46a5,5,0,0,0,0-5.2c-.3-.49-.58-1-.86-1.49s-.53-1-.77-1.54a5,5,0,0,0-4.33-2.92l-7.57-.23.75-24,7.54.24a4.94,4.94,0,0,0,4.51-2.63,34.09,34.09,0,0,1,1.85-3,5,5,0,0,0,.33-5.2l-3.56-6.65,21.17-11.36,3.57,6.66a4.94,4.94,0,0,0,4.52,2.59,31.38,31.38,0,0,1,3.49.11,5,5,0,0,0,4.68-2.31l4-6.41,20.41,12.66-4,6.42a5,5,0,0,0,0,5.22c.3.49.58,1,.85,1.5s.54,1,.79,1.55a4.94,4.94,0,0,0,4.31,2.91l7.56.24L545,317l-7.56-.23a4.93,4.93,0,0,0-4.51,2.63,31.47,31.47,0,0,1-1.83,3,5,5,0,0,0-.33,5.19l3.56,6.65Zm-8-10.25a6,6,0,0,1,5.28,3.13l3.1,5.77L533,333.76,529.9,328a5.94,5.94,0,0,1,.39-6.23,31.64,31.64,0,0,0,1.77-2.87,5.94,5.94,0,0,1,5.42-3.15l6.56.2.69-22-6.57-.21a6,6,0,0,1-5.18-3.48c-.24-.51-.49-1-.76-1.51s-.54-1-.82-1.45a6,6,0,0,1,0-6.27l3.46-5.57L516.1,263.82l-3.45,5.57a6,6,0,0,1-5.61,2.78,29.61,29.61,0,0,0-3.39-.11,6,6,0,0,1-5.42-3.12l-3.09-5.77-19.42,10.41,3.1,5.77a6,6,0,0,1-.4,6.24,32,32,0,0,0-1.79,2.88,6,6,0,0,1-5.42,3.15l-6.54-.21-.69,22,6.57.2a6,6,0,0,1,5.2,3.49c.24.51.49,1,.75,1.49s.54,1,.83,1.45a6,6,0,0,1,0,6.24l-3.47,5.61,18.71,11.61,3.46-5.58a6,6,0,0,1,5.62-2.77,31.72,31.72,0,0,0,3.38.12ZM504.38,323a19.33,19.33,0,1,1,9.13-2.29A19.34,19.34,0,0,1,504.38,323Zm-.06-37.71A18.36,18.36,0,1,0,520.54,295h0A18.41,18.41,0,0,0,504.32,285.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.93,156.4l-6-10.46-3.21,1.85a2.87,2.87,0,0,1-3-.11,17.26,17.26,0,0,0-1.57-.9,2.87,2.87,0,0,1-1.58-2.55v-3.7H76.42v3.7a2.86,2.86,0,0,1-1.59,2.55c-.53.27-1.06.58-1.56.9a2.87,2.87,0,0,1-3,.11l-3.21-1.85L61,156.4l3.22,1.86a2.89,2.89,0,0,1,1.41,2.66c0,.3,0,.6,0,.89s0,.6,0,.89a2.87,2.87,0,0,1-1.4,2.66L61,167.22l6,10.47,3.22-1.85a2.87,2.87,0,0,1,3,.11q.75.48,1.56.9a2.87,2.87,0,0,1,1.58,2.55v3.7h12.1v-3.7a2.87,2.87,0,0,1,1.58-2.55q.81-.42,1.56-.9a2.87,2.87,0,0,1,3-.11l3.22,1.85,6-10.47-3.22-1.85a2.88,2.88,0,0,1-1.4-2.66c0-.3,0-.59,0-.9s0-.59,0-.89a2.87,2.87,0,0,1,1.41-2.66Zm-11.56,5.41a9.9,9.9,0,1,1-9.9-9.9A9.9,9.9,0,0,1,92.37,161.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689,194.65l-6-10.47L679.74,186a2.89,2.89,0,0,1-3-.1,16.25,16.25,0,0,0-1.56-.91,2.86,2.86,0,0,1-1.59-2.55v-3.7h-12.1v3.7A2.87,2.87,0,0,1,659.9,185a15.27,15.27,0,0,0-1.57.91,2.89,2.89,0,0,1-3,.1l-3.21-1.85-6,10.47,3.22,1.85a2.89,2.89,0,0,1,1.41,2.66c0,.3,0,.6,0,.89s0,.6,0,.89a2.87,2.87,0,0,1-1.4,2.66l-3.23,1.86,6,10.47,3.22-1.85a2.87,2.87,0,0,1,3,.11,17.09,17.09,0,0,0,1.56.9,2.87,2.87,0,0,1,1.58,2.55v3.7h12.1v-3.7a2.87,2.87,0,0,1,1.58-2.55,17.09,17.09,0,0,0,1.56-.9,2.87,2.87,0,0,1,3-.11l3.22,1.85,6-10.47-3.22-1.85a2.87,2.87,0,0,1-1.4-2.66c0-.3,0-.59,0-.9s0-.59,0-.89a2.89,2.89,0,0,1,1.41-2.66Zm-11.56,5.4a9.9,9.9,0,1,1-9.89-9.9A9.89,9.89,0,0,1,677.43,200.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.95 312.05 241.49 312.05 241.49 454.21 206.4 454.21 206.4 312.05 195.97 312.05 223.96 281.31 251.95 312.05",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.38 421.71 102.92 421.71 102.92 454.21 67.83 454.21 67.83 421.71 57.39 421.71 85.39 390.97 113.38 421.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.24 262.19 315.78 262.19 315.78 454.21 280.69 454.21 280.69 262.19 270.26 262.19 298.25 231.46 326.24 262.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.66 366.88 172.21 366.88 172.21 454.21 137.12 454.21 137.12 366.88 126.68 366.88 154.67 336.14 182.66 366.88",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.39,454.22c203.48-.62,431.74-.62,635.22,0-203.48.61-431.74.61-635.22,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-88"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "687.91 98.15 641.01 206.57 613.58 167.86 545.28 219.19 359.23 219.19 277.38 269.71 66.87 269.71 57.4 251.83 57.4 227.57 262.58 227.57 344.44 177.05 528.03 177.05 586.7 133.47 563.49 102.22 563.49 84.34 692.61 69.4 687.91 98.15",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "687.91 98.15 641.01 206.57 613.58 167.86 545.28 219.19 359.23 219.19 277.38 269.71 66.87 269.71 57.4 251.83 57.4 227.57 262.58 227.57 344.44 177.05 528.03 177.05 586.7 133.47 563.49 102.22 563.49 84.34 692.61 69.4 687.91 98.15",
    style: {
      fill: "#030402"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "692.61 69.4 641.01 188.68 614.98 149.53 545.28 201.3 359.23 201.3 277.38 251.83 57.4 251.83 57.4 219.69 262.58 219.69 344.44 169.16 528.03 169.16 593.28 124.44 563.49 84.34 692.61 69.4",
    style: {
      fill: "#FF6200"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.86,339.35A45.38,45.38,0,0,1,451,356.8a49.12,49.12,0,0,1-2.67,7.71c-1.39,3.2-2.84,6.31-2.49,9.81.33.22-.82.19-.86-.15-9.34-5.32-21.31-6.29-28.49-15-3.41-4.12-5.12-9.33-5.94-14.55-.88-5.68-1.12-12,.34-17.57,1.24-4.73,4-9.3,8.45-11.62,4.6-2.39,10.61-2.19,15.45-.69C445.2,318,450.39,329.26,451.86,339.35Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.65,408.46c-1.27-4.25-2.54-8.5-3.85-12.73-2.56-8.3-5.23-16.57-8.17-24.74Q442,363.66,439,356.46a89.38,89.38,0,0,1,1.11-9c.78-3.62,1.92-7.11,3-10.65.07-.22-.28-.34-.37-.13-2.1,4.88-4.83,11.12-4.9,16.9q-3.42-8.15-7.34-16.06a68.82,68.82,0,0,1,.41-13.37c0-.21-.28-.27-.31-.06a47.45,47.45,0,0,0-.92,11.8q-3-5.94-6.37-11.73c-.2-.34-.68,0-.5.35,3.51,6.76,6.76,13.66,9.81,20.64A44.82,44.82,0,0,0,418,336.65c-.24-.08-.41.25-.17.35a53.57,53.57,0,0,1,15.83,10.48q3.29,7.68,6.27,15.48c-5.84-5.73-13.83-9.5-21.56-11.52-.27-.07-.34.34-.08.41,8.94,2.7,15.89,7.77,22.7,13.86.79,2.11,1.57,4.21,2.33,6.32q4.32,12,8.23,24.15,1.89,5.81,3.71,11.65c1.3,4.19,2.32,8.61,4,12.65.17.38.86.3.77-.17A116.8,116.8,0,0,0,456.65,408.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.17,331.18a23.16,23.16,0,0,0-3.36,8.38.07.07,0,0,0,.13,0,70.89,70.89,0,0,1,3.65-8.22C441.73,331.11,441.33,330.94,441.17,331.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.52,350.63a24.73,24.73,0,0,0-8.38-2.82c-.08,0-.13.1-.05.13,1.35.56,2.76.95,4.13,1.48s2.7,1.16,4.09,1.64A.24.24,0,0,0,424.52,350.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.82,327.23a16.23,16.23,0,0,0-2.69-1.66.14.14,0,0,0-.16.23,16.86,16.86,0,0,0,2.66,1.73C419.8,327.63,420,327.34,419.82,327.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.33,371.06c-6.72,2-13.48,3.84-20.2,5.81-.58.18-11.95-21.6-7.84-32.82,3.79-10.39,12.49-18.16,22.85-21.69,4.8-1.63,10.7-3,15.77-1.88,4.51,1,7.7,4.69,9.16,8.93,2,5.76,1.33,12.64.25,18.52a32.39,32.39,0,0,1-6.62,15.12C493.13,367.29,488.57,369.5,483.33,371.06Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.08,350.36a90,90,0,0,1-13.18,5.19,56.17,56.17,0,0,0-8.8,3.18c2.84-6.33,5.95-12.52,9.26-18.67,4.34-1.25,8.91-3.21,12.19-6.29a.19.19,0,0,0-.25-.28c-3.58,2.53-7.53,4.05-11.5,5.76.9-1.65,1.8-3.3,2.72-4.95.26-.45-.37-.91-.68-.46a139.28,139.28,0,0,0-9.55,16,73.61,73.61,0,0,1-.7-14.7.1.1,0,1,0-.19,0,49.18,49.18,0,0,0,.16,16.15c-2.35,4.7-4.5,9.53-6.43,14.41-.77-2.94-1.77-5.82-2.43-8.78a40.27,40.27,0,0,1-1-12.94c0-.13-.17-.14-.19,0a45.53,45.53,0,0,0,2.82,23.76c-1.12,2.94-2.2,5.89-3.18,8.85a176.2,176.2,0,0,0-8.92,46.64.29.29,0,0,0,.57.05,230.51,230.51,0,0,1,10-46.1c1.95-5.87,4.19-11.56,6.65-17.14,4-1.18,7.93-2.77,11.83-4.12s7.71-2.84,10.9-5.34A.14.14,0,0,0,493.08,350.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.35,344c-4.11,1.46-8,3.51-12.12,5-.19.07-.08.38.12.34,4.34-.9,8.65-2.24,12.16-5.09C499.64,344.16,499.49,344,499.35,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.77,335.16c.05-.22-.27-.34-.33-.12-1.13,3.79-1.91,7.81-.81,11.69a.15.15,0,0,0,.29,0C465.12,342.81,464.9,339,465.77,335.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.76,326.4a10.09,10.09,0,0,0-1.78,6.45c0,.14.24.23.28.06.5-2.17,1.33-4.15,2-6.25A.29.29,0,0,0,482.76,326.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.36,380.66c2,6.26,6.65,14.91,14.07,15,4.81,0,9.65-.53,14.47-.6,5.16-.08,10.34-.07,15.49.24.42,0-.62-15.45-13-23-3.47-2.11-7.72-2.78-11.66-3.64a53.88,53.88,0,0,0-13.79-1.43c-2.85.11-5.22.72-6.23,3.63S402.41,377.69,403.36,380.66Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.7,372.83c3,.78,6.05,1.67,9.08,2.63a32,32,0,0,0-2.5-2.44c-1.3-1.08-2.73-1.94-4.12-2.89-.12-.08-.05-.3.1-.24a17,17,0,0,1,7.31,5.82c3.77,1.22,7.51,2.56,11.1,4a41,41,0,0,1,7.11,3.74,28.85,28.85,0,0,0-2.57-4.48c-1.65-2.13-3.88-3.32-6-4.83a.19.19,0,0,1,.19-.33,17.63,17.63,0,0,1,9.68,10.49,41,41,0,0,1,7,6.39c8.21,9.32,14.68,21.72,14.7,34.38,0,.3-.49.39-.54.07a70.17,70.17,0,0,0-15.66-33.62c-.58-.68-1.19-1.34-1.8-2a56.8,56.8,0,0,0-6.78-.5c-2.64,0-5.26.39-7.89.6-4.33.35-9.12.4-13-1.78-.17-.09-.05-.39.14-.32,8.71,3.17,17.84-.85,26.57,1a40.56,40.56,0,0,0-12.87-8.3l-.8-.33c-5.59.68-11.49,2.13-16.93.32a.13.13,0,0,1,.07-.26c5.26,1.31,10.3-.34,15.49-.6-5.65-2.2-11.41-3.95-17.08-6.14C408.19,373.14,408.18,372.7,408.7,372.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.23,378.34a73.93,73.93,0,0,0,8.14.61.06.06,0,0,1,0,.12,16.83,16.83,0,0,1-8.21-.53C406,378.5,406.1,378.32,406.23,378.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.6,373a13.16,13.16,0,0,1,4,2.8c.14.13-.05.38-.21.27-.68-.5-1.38-1-2.09-1.43a18,18,0,0,1-2-1.24C424.18,373.22,424.38,372.9,424.6,373Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.41,393.11c-.1.21.2.4.31.19,0,0,0,0,0,0a.27.27,0,0,0,.19.13,124,124,0,0,0,15.15,2.64c4.11.37,8.83.6,12.42-1.79,4.87-3.22,8.07-11.85,5.44-17.33-3.11-6.5-12.49-3-17.2-.66A34.58,34.58,0,0,0,468.41,393.11Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.77,396.12a48.33,48.33,0,0,1,9.05-6.89,31,31,0,0,1,9.17-9.35c.18-.12.33.16.17.29a40.74,40.74,0,0,0-7.73,8.13,84.84,84.84,0,0,1,11.35-5.16,15,15,0,0,1,6.1-6.11c.05,0,.11,0,.06.08a25,25,0,0,0-5.51,5.78c2.31-.86,4.64-1.66,7-2.44.21-.07.29.25.09.33-4.15,1.62-8.38,3.33-12.49,5.3a48.23,48.23,0,0,0,15.12-.05c.14,0,.2.18.06.22a29.86,29.86,0,0,1-16.05.24,76.37,76.37,0,0,0-7.61,4.26,19.17,19.17,0,0,1,6.15.5,46.47,46.47,0,0,0,10.82,1.23c.13,0,.17.22,0,.24-6.27,1.08-12.2-1.77-18.42-1a46.18,46.18,0,0,0-15.92,18.61c-2.61,5.33-4,11-6.15,16.48a.2.2,0,0,1-.38-.11C451.46,415.82,456.86,403.86,464.77,396.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.68,381.24a7.36,7.36,0,0,1,1.61-1.95,6.22,6.22,0,0,1,1.85-1.38c.06,0,.1.06.06.1-.51.59-1.23,1-1.78,1.57s-1,1.22-1.59,1.78A.1.1,0,0,1,483.68,381.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494,384.61c.93-.23,1.91-.22,2.86-.41a27.47,27.47,0,0,0,2.77-.83.11.11,0,0,1,.08.2A9.15,9.15,0,0,1,494,384.9.15.15,0,0,1,494,384.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.92 413.3 439.75 422.65 442.54 454.21 467.26 454.21 470.75 422.65 471.78 413.3 438.92 413.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.92 413.3 439.75 422.65 470.75 422.65 471.78 413.3 438.92 413.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.48,
    y: 410.75,
    width: 37.75,
    height: 7.58,
    transform: "translate(910.71 829.09) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.86,462.28c2.27.73,66.93-.06,69.38-1.64.92-.6,1.36-10,1.56-21.43q.06-3.69.09-7.59c0-3.05,0-6.15,0-9.16,0-13.5-.64-25.39-.64-25.39l-41.8.39.26,25.39.09,9.16.29,7.59S511.49,451,509,453,504.6,461.56,506.86,462.28Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.86,462.28c2.27.73,66.93-.06,69.38-1.64.92-.6,1.36-10,1.56-21.43q.06-3.69.09-7.59c0-3.05,0-6.15,0-9.16l-42.18.39.09,9.16.29,7.59S511.49,451,509,453,504.6,461.56,506.86,462.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.67,462.38c1.47.47,29,.31,49.06-.29,4.64-.14,8.88-.31,12.31-.49,4.71-.26,7.88-.55,8.39-.88,1.13-.74,1.54-14.57,1.67-29.17l-42.3.39.28,7.63S511.33,451,508.82,453.05,504.39,461.64,506.67,462.38Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.57,459.77c10.89-.4,54.87-1,65.68-.56.08,0,.08.07,0,.07-10.79.63-54.78.86-65.68.66C507.34,459.94,507.34,459.77,507.57,459.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.52,437.17c4.27-.86,9.53-.26,12.84,2.76.13.11,0,.29-.18.25a60.29,60.29,0,0,0-12.64-2.47A.27.27,0,0,1,534.52,437.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.44,439.07c4.28-.85,9.53-.26,12.85,2.76.13.12,0,.3-.18.25a60.41,60.41,0,0,0-12.64-2.47A.27.27,0,0,1,531.44,439.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.37,441c4.28-.85,9.53-.25,12.85,2.76.12.12,0,.3-.18.26a60.38,60.38,0,0,0-12.65-2.47A.28.28,0,0,1,528.37,441Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.3,442.88c4.28-.86,9.53-.26,12.84,2.75.13.12,0,.3-.18.26a60.29,60.29,0,0,0-12.64-2.47A.27.27,0,0,1,525.3,442.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.47,433.43c3.06,2.32,7,3.24,10.58,4.51.37.13.66-.22.67-.55a.11.11,0,0,0,.09-.15,22.86,22.86,0,0,0-6.72-9.75c-1.81-1.48-5-2.49-6.62-.14S526.68,432.07,528.47,433.43ZM527.34,430c-.82-4.69,4.27-2.28,5.55-1.14a25.24,25.24,0,0,1,2.31,2.43c1.51,1.76,2.73,3.71,4,5.6-1.71-.73-3.47-1.3-5.2-2C532,434.12,527.78,432.58,527.34,430Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.05,430.53c-1.07-2.66-4.36-2.42-6.47-1.39a22.91,22.91,0,0,0-8.8,7.92.11.11,0,0,0,.06.17c-.06.32.14.73.53.69,3.75-.41,7.82-.39,11.33-1.94C552.75,435.08,555.06,433.05,554.05,430.53Zm-9.12,5.6c-1.84.25-3.68.4-5.51.72a68.48,68.48,0,0,1,5.24-4.52,23.55,23.55,0,0,1,2.8-1.82c1.52-.82,7-2,5.14,2.39C551.56,435.32,547.13,435.84,544.93,436.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,437.53c-.18,12.19-.62,22.55-1.59,23.19-.52.34-3.68.63-8.39.88-3.43.18-7.67.35-12.3.49-3,.1-6.14.17-9.34.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.51,210.8s-21,111-22.51,119.21c-.35,1.86,4.25,101.61,4.25,101.61l-47.4.38s-.76-87.18,1.07-103.54,25.88-117.3,25.88-117.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.51,210.81s-10.23,54-16.94,89.48L559.8,211.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.57,422.43c-2.65-.32-22.84-.83-39.72,0a.09.09,0,1,0,0,.17c5.51.44,36.61.37,39.7,0C575.66,422.61,575.69,422.44,575.57,422.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.37,416.09c-.25.22-.68.31-.7-.11-1.06-26.9-1.6-58.85-2.12-85.5a14.63,14.63,0,0,1,.26-3.23c5.27-28.47,20.91-106.41,22.08-111.9.21-1,.77,0,.77,0l-4.82,24.92c-4.37,22.54-12.81,64.42-17.09,87.13a13.84,13.84,0,0,0-.26,3.08c.48,26.31,1.42,59.25,1.88,85.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.53,462c2.26.75,66.92.61,69.39-1,.93-.58,1.46-10,1.77-21.4.07-2.47.12-5,.17-7.59,0-3.06.09-6.15.11-9.16.09-13.5-1.16-25.56-1.16-25.56l-41,.14v34.55l.21,7.59s-24.73,11.13-27.24,13.14S557.27,461.28,559.53,462Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.53,462c2.26.75,66.92.61,69.39-1,.93-.58,1.46-10,1.77-21.4.07-2.47.12-5,.17-7.59,0-3.06.09-6.15.11-9.16l-42.18,0v9.16l.21,7.59s-24.73,11.13-27.24,13.14S557.27,461.28,559.53,462Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.33,462.12c1.48.49,29,.61,49.07.21,4.64-.1,8.89-.23,12.31-.37,4.72-.22,7.88-.47,8.4-.8,1.14-.73,1.69-14.56,2-29.15l-42.31,0,.22,7.63s-24.87,11.19-27.4,13.21S557.07,461.36,559.33,462.12Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.26,459.52c10.9-.29,54.89-.44,65.68.1.09,0,.09.06,0,.07-10.8.52-54.78.32-65.68,0C560,459.69,560,459.53,560.26,459.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.43,437.19c4.29-.81,9.54-.16,12.82,2.89.13.12,0,.29-.18.25a61,61,0,0,0-12.62-2.6A.27.27,0,0,1,587.43,437.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.34,439.06c4.29-.81,9.53-.16,12.82,2.89.13.12,0,.3-.18.25a60.32,60.32,0,0,0-12.62-2.59A.28.28,0,0,1,584.34,439.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.25,440.94c4.29-.81,9.53-.17,12.82,2.88.12.12-.05.3-.18.26a59.71,59.71,0,0,0-12.62-2.6A.27.27,0,0,1,581.25,440.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.16,442.81c4.28-.81,9.53-.16,12.82,2.88.12.12-.05.3-.19.26a60.11,60.11,0,0,0-12.61-2.6A.27.27,0,0,1,578.16,442.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.42,433.4c3,2.35,7,3.3,10.54,4.61a.54.54,0,0,0,.67-.54.12.12,0,0,0,.1-.16,22.89,22.89,0,0,0-6.63-9.81c-1.79-1.5-4.93-2.53-6.61-.21S579.65,432,581.42,433.4Zm-1.1-3.45c-.76-4.71,4.3-2.25,5.57-1.09a23,23,0,0,1,2.28,2.45c1.49,1.78,2.7,3.74,4,5.65-1.7-.75-3.45-1.35-5.18-2C584.93,434.12,580.75,432.54,580.32,430Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607,430.75c-1-2.68-4.34-2.46-6.45-1.46a23,23,0,0,0-8.88,7.84.11.11,0,0,0,.06.17c-.07.32.13.73.51.69,3.76-.37,7.83-.31,11.36-1.82C605.69,435.29,608,433.27,607,430.75Zm-9.17,5.51c-1.85.23-3.69.36-5.53.66,1.74-1.52,3.4-3.11,5.29-4.46a24.47,24.47,0,0,1,2.82-1.8c1.53-.8,7-1.91,5.12,2.45C604.5,435.51,600.05,436,597.86,436.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.8,431.55h47.44s-11.92-150.38-15.81-180.27c0,0,2-5.62,1.68-9.71a110.43,110.43,0,0,0-8-30.92l-51.34.48s3.66,23.26,9.68,38a54.62,54.62,0,0,1,10.79,4.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.49,247.73a84.89,84.89,0,0,1,13.42,6.1.15.15,0,0,1-.12.28c-4.52-1.89-9.13-3.7-13.54-5.84A.3.3,0,0,1,567.49,247.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.77,216.86c0-.15.29-.19.29,0,0,5.34.4,10,.89,15,.23,2.31,2.22,15.11,6.23,14.14.67-.16,1-.83,1.1-1.85a15.54,15.54,0,0,0-.57-3.92c-.47-2.68-.85-5.37-1.11-8.07a73.86,73.86,0,0,1,0-15.16.13.13,0,0,1,.26,0,139.23,139.23,0,0,0,1.41,20.91c.54,3.33,2.26,8.33-1.22,8.88s-5.92-7.83-6.37-10.12A77,77,0,0,1,565.77,216.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.07,246.35A19.37,19.37,0,0,1,574,249a6.09,6.09,0,0,1,.4,2.18.16.16,0,0,1-.28.06,7.59,7.59,0,0,1-1-2.11c-.32-.82-.65-1.63-.94-2.46A.45.45,0,0,1,573.07,246.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.76,234.06c-3.8-.34-7.71-.26-11.25-1.92s-5.9-5.06-7.76-8.46a28.23,28.23,0,0,1-2.59-6.66c0-.1-.19-.07-.18,0a18.65,18.65,0,0,0,1.61,6.3,28.13,28.13,0,0,0,3.06,5.56,13.62,13.62,0,0,0,4.38,4,15.06,15.06,0,0,0,5.72,1.67,32.32,32.32,0,0,0,7-.11A.22.22,0,0,0,608.76,234.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.56,232.73a5.09,5.09,0,0,0,3.62-1.93c1.58-1.63,2.56-4.79,3.34-8a46,46,0,0,0,1.06-6.23c0-.1.09-.08.09,0a33.71,33.71,0,0,1-.64,5.88,40.49,40.49,0,0,1-1.29,5.21,11.79,11.79,0,0,1-1.89,3.81,4.68,4.68,0,0,1-2.52,1.63,2.27,2.27,0,0,1-1.77,0C555.44,233.11,555.44,232.76,555.56,232.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.58,422.91c-2.66-.32-22.85-.84-39.73,0-.11,0-.1.16,0,.17,5.5.44,36.6.37,39.7,0C628.66,423.09,628.7,422.92,628.58,422.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.26,417.92c-.23.32-.45.08-.47-.13-5.52-54.85-10.52-111-15-165.89A18.78,18.78,0,0,0,614.2,243c.29-3.21-1-6.84-1.52-10-1.18-5.8-3.08-12.56-4.63-18.28-.15-.58.42-.34.42-.34,1.84,6.26,3.59,12.56,5,18.93.64,3.22,1.51,6.44,1.24,9.75a19.35,19.35,0,0,1-3.46,9.22c5.48,53.76,10.44,110.9,15,165.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609,159.62c-.51,3.67,1.23,5.18,1.07,7.16,0,0-8.93,2.78-23.12.8s-22-7.11-22-7.11c.38-1.95,2.47-2.92,3-6.6.6-4.24-2.2-5-.63-11.28,1.17-4.72,4.85-4.8,6.74-14.13,1.94-9.64,6.18-13,9.35-14.85a16.23,16.23,0,0,1,11.41-2.1s5.21-.3,10.16,4.76c2.55,2.61,5.93,7.43,5.16,17.24-.75,9.48,2.76,10.57,2.59,15.43C612.46,155.46,609.58,155.38,609,159.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.08,133.68c1.6-2.52,2-5.73,2.18-8.69a.11.11,0,0,0-.21,0c-.42,2.8-.7,5.72-2.19,8.16-1.28,2.12-3.31,3.48-5,5.21a10.22,10.22,0,0,0-2.89,5.84,10,10,0,0,0,.15,3.45,23.63,23.63,0,0,0,1.29,3.27c1.29,3.35-1.26,6.37-3.31,8.59,0,0,0,.06,0,0,1.67-1.65,3.47-3.49,4-6a5.74,5.74,0,0,0-.47-3.5,11.19,11.19,0,0,1-1.14-3.79,9.57,9.57,0,0,1,2.59-7.32C569.73,137.15,571.75,135.78,573.08,133.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.13,148.84c-.12-2.79-1.26-5-2.42-7.42a17,17,0,0,1-1.37-3.64,22.05,22.05,0,0,1-.38-4.45c0-1.63,0-3.26-.17-4.89a29.68,29.68,0,0,0-1-4.77c0-.07-.12,0-.1,0a32.48,32.48,0,0,1,.89,9.08,18.21,18.21,0,0,0,1.26,7.88c1.07,2.4,2.47,4.6,2.76,7.33.31,2.91,0,6.44-1.75,8.81-1.46,1.94-4.08,4.07-3.24,6.92,0,.09.17,0,.16-.05-.59-3.19,2.36-5,3.82-7.28S614.24,151.36,614.13,148.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.58,190.07,558,211.58h54.69s-4-39.18-12.48-51.69c-6.12-9.07-12.35-8.82-18.85-4.32-1.64,1.14-15.73,15.17-19,23.16C559.45,185.77,563.58,190.07,563.58,190.07Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.41,189.22c-.23.08-.46.17-.68.27a12.36,12.36,0,0,0-2.89,1.76,11.74,11.74,0,0,0,3.25-.95l.48-.23C609.52,189.79,609.47,189.51,609.41,189.22Zm-37.47-7.94a11.68,11.68,0,0,0-2.88,1.78,11.91,11.91,0,0,0,3.24-1,11.41,11.41,0,0,0,2.89-1.77A12.32,12.32,0,0,0,571.94,181.28Zm-3.29,23.09a12,12,0,0,0-.8,3.29,13,13,0,0,0,2.41-6.26A11.91,11.91,0,0,0,568.65,204.37Zm25.32.72a12,12,0,0,0-.8,3.29,13.06,13.06,0,0,0,2.41-6.27A12,12,0,0,0,594,205.09Zm-10.92-39.92a12,12,0,0,0-3.29-.79,12,12,0,0,0,3,1.62,11.66,11.66,0,0,0,3.28.79A12,12,0,0,0,583.05,165.17Zm2.38,28a11.58,11.58,0,0,0-3.29-.81,12.25,12.25,0,0,0,3,1.62,11.94,11.94,0,0,0,3.28.8A11.07,11.07,0,0,0,585.43,193.18ZM595.17,177a11.31,11.31,0,0,0-.79,3.29,12.31,12.31,0,0,0,1.61-3,12,12,0,0,0,.79-3.28A11.91,11.91,0,0,0,595.17,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.61,187.23a40.93,40.93,0,0,1,6.66,3c1.05.61,2.07,1.28,3.08,2,.51.35,1,.68,1.53,1a6.93,6.93,0,0,0,1.71.83s0,.11,0,.1a11.42,11.42,0,0,1-1.72-.44,10.22,10.22,0,0,1-1.56-.76c-1.08-.61-2.12-1.28-3.19-1.9-2.16-1.26-4.32-2.52-6.56-3.59C572.43,187.41,572.5,187.19,572.61,187.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.24,188.4a43.55,43.55,0,0,1,5.9,1,29.44,29.44,0,0,1,2.86.88c.45.16.89.33,1.34.51s.95.47,1.44.66c.05,0,0,.12,0,.1-.47-.16-1-.22-1.45-.35l-1.44-.38c-1-.25-1.93-.49-2.89-.76-1.93-.53-3.85-1-5.79-1.47C566.09,188.57,566.14,188.39,566.24,188.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.15,156c-.35,1.05-6.13,7.52-11,6.82-1.59-.23-.72-9-.72-9l-.08-.66L580.18,144l11.26-5.79,1.62-.76s.15,2.55.3,5.72c0,.15,0,.29,0,.45s0,.35,0,.52c0,.47.05,1,.07,1.43s0,.73,0,1.11,0,.77,0,1.15A59.05,59.05,0,0,1,593.15,156Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.18,144l1.11,8.86a19.93,19.93,0,0,0,12.12-8.8l0-.89c-.16-3.17-.3-5.71-.3-5.71l-1.62.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.11,127.69c-5.43,15.39,3.17,20.37,6.49,21.54,3,1.06,13.41,4.28,20.39-10.46s1.55-22.13-5.21-24.92S575.53,112.31,570.11,127.69Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.73,126.5a8.41,8.41,0,0,0,1.12.06,1.85,1.85,0,0,0,1.16-.15.58.58,0,0,0,.18-.69,1.43,1.43,0,0,0-1.28-.69,2.12,2.12,0,0,0-1.48.38A.62.62,0,0,0,572.73,126.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.41,129.37a8.54,8.54,0,0,1-1-.51,1.81,1.81,0,0,1-.93-.72.58.58,0,0,1,.18-.68,1.44,1.44,0,0,1,1.46,0,2.11,2.11,0,0,1,1.09,1.07A.62.62,0,0,1,583.41,129.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.38,131.59s.06.07,0,.12c-.35,1-.57,2.32.3,3,0,0,0,.07,0,.05C579.57,134.21,579.88,132.53,580.38,131.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.65,130.75c1.76.37.88,3.85-.74,3.51S580.18,130.44,581.65,130.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.29,131.11c.25.27.46.69.82.82s.83-.13,1.19-.41c0,0,.06,0,.05,0-.16.67-.59,1.29-1.32,1.21s-1-.78-1-1.49C582,131.15,582.19,131,582.29,131.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.37,129.93s-.09,0-.1.08c-.25,1.08-.72,2.28-1.79,2.38a0,0,0,0,0,0,.06C573.71,132.6,574.31,131,574.37,129.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.71,128.56c-1.69-.59-2.74,2.84-1.17,3.38S575.13,129.05,573.71,128.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.93,128.56c-.33.1-.7.35-1,.27s-.55-.54-.68-1c0,0-.05,0-.06,0-.22.65-.21,1.4.38,1.72s1.13-.15,1.49-.75C573.09,128.74,573.06,128.52,572.93,128.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.44,141a1.67,1.67,0,0,1-1.09.33,2.87,2.87,0,0,1-1-.64s-.08,0-.07,0a1.48,1.48,0,0,0,1.15,1,1.18,1.18,0,0,0,1.14-.65C578.57,141,578.49,141,578.44,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.62,137.51a3.7,3.7,0,0,1-2.87.75,4.83,4.83,0,0,1-1.28-.38l-.23-.11-.21-.11a.26.26,0,0,1-.13-.3h0a.93.93,0,0,1,.05-.1h0l0-.09c.25-.8.74-2,.74-2-.34,0-2,.2-1.88-.21a55.67,55.67,0,0,1,5-10.11.1.1,0,0,1,.17.09c-1.2,3.27-3,6.31-4.23,9.57a6.74,6.74,0,0,1,1.82.07c.1.07-1,2.26-1.08,2.63v0a5.16,5.16,0,0,0,4,.12C578.65,137.35,578.71,137.45,578.62,137.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.85,137.65a4.55,4.55,0,0,0,1.23,1.94,2,2,0,0,0,1.14.49c.92.09,1.22-.68,1.31-1.39a5,5,0,0,0,0-1.15A5.93,5.93,0,0,1,574.85,137.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.08,139.59a2,2,0,0,0,1.14.49c.92.09,1.22-.68,1.31-1.39A2.1,2.1,0,0,0,576.08,139.59Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.71,140.12a6.62,6.62,0,0,1-2.09-6.22,17.23,17.23,0,0,1-5.23-7.4c0,.35.1,2.86.18,4.15-9.31-4.66-10.2-13-10.2-13a17.58,17.58,0,0,0-6.08,5s1.66-6,5.93-9.19A10.17,10.17,0,0,1,588.36,112a14.5,14.5,0,0,1,12.39,8C605.15,128.83,595.71,140.12,595.71,140.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.56,126.88a18.7,18.7,0,0,0,4.52,3.29s0,0,0,0a16,16,0,0,1-6-6.42,15.2,15.2,0,0,1-1.27-3.57,10.56,10.56,0,0,1-.23-4.11.08.08,0,0,0-.16,0,12.51,12.51,0,0,0-.33,4.09,11.34,11.34,0,0,0,1.25,3.87,12.86,12.86,0,0,0,2.19,2.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.13,139.09s4.72-4.05,6.64-2.24-2.52,8.29-5.39,8.59a2.76,2.76,0,0,1-3.21-2.36Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.45,138.68s0,.06,0,.07c-2,.27-3.45,1.73-4.58,3.32a1.52,1.52,0,0,1,2.31.17s0,.11-.08.09a1.68,1.68,0,0,0-2,.1,9.16,9.16,0,0,0-1.25,1.24c-.12.14-.4,0-.29-.19l0,0C594.2,141.08,596.87,138.26,599.45,138.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.75,144.25a.8.8,0,1,0,1-.57A.8.8,0,0,0,593.75,144.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.77,172.68c-1.86,8.48-8.82,38.46-17.37,45.38-5.56,4.51-30,10.11-39,10.1-3.75,0-7.47-27.11-3.51-26.51,2.92.44,25.89-2.92,28.81-3.56,0,0,11.38-17.25,19.36-29.38S600.9,158.44,597.77,172.68Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.63,204.3c1.67-.61,1.36-1.49-1.64-2.46s-15.72-2.28-14.89-6.68,18.74-2.29,23.62-.29,12.06,6.95,12.06,6.95C542.21,202.11,533.62,203.64,526.63,204.3Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545,228.16c-10.08.45-22.59,1.63-32.65-3.7a5.65,5.65,0,0,1-2.58-2.64c-4.55-2.31-4.83-5.15-4.83-5.15-3.58-3.45-3.46-6.39-3.46-6.39s-5.31-2.77-4.17-6.26c1.27-3.91,8.48.74,14,.88,12.67.3,30.77-2.8,34.44-3.08Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.39,214.55a57,57,0,0,1-22.76-4.33.1.1,0,0,0-.08.18,43.08,43.08,0,0,0,22.84,4.32C524.57,214.71,524.58,214.56,524.39,214.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.32,222.23c-3.62-.36-10-1-20.31-5.67,0,0-.07,0,0,.06a38.68,38.68,0,0,0,20.32,5.78C525.53,222.4,525.56,222.25,525.32,222.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.74,226.36c-6.13-.85-9.89-2.16-15.92-4.55,0,0-.07,0,0,.06,6.57,3.44,9.34,3.94,15.95,4.71C526,226.6,526,226.4,525.74,226.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,183.24l18.91,16.22s6.15-26.7,5.74-35.06c-.46-9.41-5.17-7.12-11.24-.54S574,183.24,574,183.24Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.32,166.29h0l-.29.37a8.28,8.28,0,0,0,1,.13C585.79,166.61,585.56,166.45,585.32,166.29Zm.38,27,1.56,1.34a8.61,8.61,0,0,0,1.15.17A10.51,10.51,0,0,0,585.7,193.28ZM595.17,177a11.31,11.31,0,0,0-.79,3.29,12.31,12.31,0,0,0,1.61-3,12,12,0,0,0,.79-3.28A11.91,11.91,0,0,0,595.17,177Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.12,193.82c-.57-.66-6.38-5.81-7.67-6.9s-6.51-5.6-7.93-6.62c-.07,0-.14,0-.09.09,1.2,1.26,6.46,5.83,7.74,7s7.16,6.11,7.88,6.57C593.11,194,593.15,193.87,593.12,193.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.49,184.51c-.53-.52-1.39-1.32-1.39-1.32,1.41-2.52,9.72-14.62,11.67-17.57,0-.05,0-.09-.07-.05-1.21,1.6-2.41,3.2-3.6,4.82.11-.23.22-.46.34-.68.4-.81.78-1.63,1.21-2.42a.06.06,0,0,0-.1-.07,22.21,22.21,0,0,0-1.38,2.35c-.28.58-.52,1.17-.75,1.77-.68.93-1.36,1.85-2,2.8-2,2.91-4.19,5.85-6,8.91a13.29,13.29,0,0,0,1.95,1.61C575.49,184.71,575.57,184.59,575.49,184.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.07,197.89c.65.47,1.29,1,1.93,1.45l-.26.08c.52-2.4,1.54-7.23,2-9.64.61-2.83,1.41-6.85,2.05-9.64A84.2,84.2,0,0,1,593,199.76c-.63-.62-1.28-1.23-1.9-1.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.83,186.28a19.3,19.3,0,0,1,1.54-3.66,5.07,5.07,0,0,1-1.54,3.66Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.65,151.12s2.22,53,3.64,57.88,16.36,51.31,16.36,51.31,13.06-5.47,16.55-8.55c2.51-2.21,10.9-12.7,10.9-12.7s-23.22-30-25.85-36.52-9.68-39-12.52-45.25a13.59,13.59,0,0,0-9.46-7.38",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.65,151.12s2.22,53,3.64,57.88,16.36,51.31,16.36,51.31,13.06-5.47,16.55-8.55c2.51-2.21,10.9-12.7,10.9-12.7s-23.22-30-25.85-36.52-9.68-39-12.52-45.25a13.59,13.59,0,0,0-9.46-7.38",
    style: {
      fill: "#030402",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,372.7s-20.56,37.15-20.57,37.18c-3.29,7.48-6,14.1-7.14,17.66a.11.11,0,0,0,0,.06,5.52,5.52,0,0,0-.46,2.55.64.64,0,0,0,0,.07c1.56,2.48,60.6,30.51,63,30.8s3.39-6.5,2-9.42-19.23-23.76-19.23-23.76L359,390.55Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.07,461c-2.39-.29-61.43-28.32-63-30.8a.64.64,0,0,1,0-.07,5.57,5.57,0,0,1,.46-2.56s0,0,0,0c1.1-3.56,3.86-10.18,7.14-17.67,0,0,2.21-4,5.19-9.36l37.61,18.69-4.68,8.64S356.59,448.68,358,451.6,358.47,461.31,356.07,461Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.07,461c-2.39-.29-61.43-28.32-63-30.8a.64.64,0,0,1,0-.07,5.57,5.57,0,0,1,.46-2.56s0,0,0,0c1.1-3.56,3.86-10.18,7.14-17.67l1.12-2,37.89,18.34-.89,1.65S356.59,448.68,358,451.6,358.47,461.31,356.07,461Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.07,461a48.64,48.64,0,0,1-5.37-2.2l-7.41-25.67c5.38,6.38,13.78,16.48,14.75,18.45C359.45,454.51,358.47,461.31,356.07,461Z",
    style: {
      fill: "#030402",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.92,458c-9.8-5.24-49.81-25.45-59.89-29.88-.08,0-.11,0,0,.06,9.6,5.4,49.77,25.29,59.83,30C356.05,458.23,356.12,458.08,355.92,458Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.94,428.46c-3.54-2.69-8.62-4.5-13-3.22-.17.05-.1.29.05.32A60.74,60.74,0,0,1,341.67,429,.28.28,0,0,0,341.94,428.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.9,431.58c-3.54-2.69-8.61-4.5-13-3.22-.17.05-.09.29.05.31a61.39,61.39,0,0,1,12.68,3.4A.28.28,0,0,0,343.9,431.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.86,434.7c-3.54-2.7-8.61-4.5-13-3.22-.17,0-.09.29.05.31a61.92,61.92,0,0,1,12.69,3.39A.28.28,0,0,0,345.86,434.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.36,418.89c-3.19-4.28-9.85.67-6.65,5S310.56,423.18,307.36,418.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.4,397.67l42.33,22.11s52.48-76.26,53.36-96.17C402.31,296.1,378,209,378,209l-37.44.08s16,89.63,14.94,105C355,322.09,305.4,397.67,305.4,397.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.33,411c-2.19-1.54-22.26-12.93-37.53-20.18-.1-.05-.17.1-.08.16,4.64,3,34.59,19.05,37.5,20.19C351.31,411.24,351.42,411.11,351.33,411Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.55,294.84c-1.86-13.12-3.89-26.22-6.19-39.27s-4.74-26.21-7.61-39.21c-.35-1.58-.71-3.17-1.07-4.75a.2.2,0,0,0-.39.08c2.43,12.9,4.92,25.79,7.16,38.72s4.34,25.9,6.24,38.89c.47,3.21.92,6.43,1.37,9.65a86.61,86.61,0,0,1,1.05,10,25.83,25.83,0,0,1-1.52,9.42,54.24,54.24,0,0,1-4.24,8.49c-6.67,11.52-36.55,61.88-37.33,63.35,0,.09.09.19.15.1,7.17-11.37,29.43-47.66,36.2-59.37,3.05-5.28,6.55-10.63,7.51-16.77C362.87,307.81,361.45,301.16,360.55,294.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.7,397.26s0,42.73,0,42.76c.31,8.17.71,15.32,1.27,19a.13.13,0,0,0,0,.06,5.74,5.74,0,0,0,.7,2.51l.05,0c2.49,1.56,67.84,1.06,70.12.28s.21-7.33-2.34-9.33-27.67-13-27.67-13l-.37-42.69Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.57,430.48s.1,9.51.09,9.54c.31,8.17.71,15.32,1.27,19a.13.13,0,0,0,0,.06,11.22,11.22,0,0,0,.7,2.51l.05,0c2.49,1.56,67.84,1.06,70.12.28s.21-7.33-2.34-9.33-27.67-13-27.67-13l-.08-8.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.81,461.91c-2.27.78-67.63,1.29-70.12-.27,0,0,0,0-.05-.06a11.05,11.05,0,0,1-.7-2.5.09.09,0,0,1,0-.05c-.55-3.69-1-10.84-1.26-19v-1.38H392.8v.93s25.09,11,27.66,13S425.09,461.13,422.81,461.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,459.27c-11.1-.37-55.92-.8-66.92-.32-.09,0-.09.07,0,.07,11,.6,55.82.67,66.92.43C422.35,459.44,422.35,459.28,422.11,459.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.53,439c-4.37-.85-9.72-.23-13.08,2.86-.13.12,0,.3.18.26a61.29,61.29,0,0,1,12.87-2.57A.28.28,0,0,0,396.53,439Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.66,440.92c-4.36-.86-9.71-.23-13.07,2.85-.14.12,0,.31.18.26a61.28,61.28,0,0,1,12.87-2.56A.28.28,0,0,0,399.66,440.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8,442.84c-4.36-.85-9.71-.22-13.08,2.86-.13.12,0,.31.19.26a61.15,61.15,0,0,1,12.87-2.56A.28.28,0,0,0,402.8,442.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.29,445.69c-4.76-2.42-8.54,5-3.78,7.4S366.05,448.13,361.29,445.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.56,209a.16.16,0,0,1,0,0c-.24.77-13.36,37.77-14.63,38.37-1.43.67,30.22,52.74,32.28,77C396.52,339.94,395,428,395,428l-45.56.42s1.47-79.16,2.28-104.24c.32-9.73-31.81-57.85-32.47-88-.21-9.5,6.46-26.92,6.46-26.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,323.48c0-.4-.32-.53-.35-.12-.91,13.58-1,27.08-1.55,40.68s-.12,16.82-.6,30.38c-.28,7.67.12,15.36,0,23a.1.1,0,0,0,.19,0C351,403.93,352.05,331.16,352,323.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.21,324.93a68.2,68.2,0,0,0-1-10,48.89,48.89,0,0,0-2.9-9.35c-2.57-6.33-5.6-12.49-8.5-18.67s-5.94-12.49-9-18.68q-2.61-5.21-5.25-10.41c-1.79-3.5-3.7-6.95-5.57-10.41a.12.12,0,0,0-.22.11c3,6.24,5.92,12.5,8.9,18.75s5.9,12.51,8.82,18.78,5.77,12.33,8.48,18.57a61.43,61.43,0,0,1,3.34,9.18,54.42,54.42,0,0,1,1.42,9.91c.51,7.78.8,15.59,1.64,23.34a.09.09,0,0,0,.17,0C395.66,339,395.48,332,395.21,324.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.63,419c-2.65-.32-22.84-.84-39.73,0-.11,0-.1.16,0,.17,5.51.44,36.61.37,39.7,0C391.71,419.19,391.75,419,391.63,419Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.2,245.25a88.59,88.59,0,0,0-14.2,5.07.16.16,0,0,0,.1.3c4.77-1.55,9.62-3,14.3-4.8A.3.3,0,0,0,369.2,245.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.51,214c0-.16-.27-.22-.29,0-.47,5.45-1.26,10.2-2.19,15.25-.44,2.34-3.55,15.21-7.56,13.88-.67-.22-1-.93-1-2a16.73,16.73,0,0,1,.92-4c.71-2.69,1.33-5.39,1.82-8.13a74.9,74.9,0,0,0,1.27-15.46.13.13,0,0,0-.26,0,141.52,141.52,0,0,1-3.24,21.2c-.83,3.35-3,8.3.49,9.15s6.7-7.47,7.36-9.77A78.56,78.56,0,0,0,373.51,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.55,243.42a21.2,21.2,0,0,0-1.18,2.62,6.26,6.26,0,0,0-.59,2.19.16.16,0,0,0,.28.09,7.68,7.68,0,0,0,1.15-2.08c.39-.81.8-1.61,1.17-2.43A.46.46,0,0,0,363.55,243.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,336.83c.18-6.48.84-13.28-1.34-19.51a65.69,65.69,0,0,0-4.24-8.83c-1.61-3-3.18-6.08-4.74-9.14-6.19-12.24-12-24.68-17.28-37.36-2.53-6.11-4.79-12.38-5.73-19a58.28,58.28,0,0,1,1.08-20.68c.37-1.69.76-3.37,1.21-5,0-.12-.15-.19-.19-.06a68,68,0,0,0-3.37,19.79,55.86,55.86,0,0,0,3.6,18.86c2.24,6.34,5,12.5,7.78,18.63q4.26,9.48,8.83,18.81c3,6.18,6.27,12.26,9.47,18.37a33.34,33.34,0,0,1,3.59,9.27,47.64,47.64,0,0,1,.46,10.2c-.4,14.33-1.2,62-1.25,76.32,0,1.82,0,3.63,0,5.45a.13.13,0,0,0,.25,0C355.66,398.71,356.39,351.12,356.77,336.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.48,218.52c0-.1-.16-.08-.18,0-.5,3.95-.77,8-2.64,11.64-1.72,3.3-4.74,5.44-8.05,7a58.2,58.2,0,0,1-5.9,2.24c-.14,0-.1.27.05.24,3.76-.82,7.59-1.73,10.84-3.88,3.49-2.3,5.26-5.94,5.8-10A34.65,34.65,0,0,0,345.48,218.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,223.68c.14.18,68.22,5.74,68.86,5.13.06-.06,2.47-2,2.12-7.12-.1-1.41-3.05-7-3.91-11.35-3-15.33-7.74-43.94-14.77-58.47-1.89-3.91-11.63-7-15.94-3.07C332.06,166.36,314.92,223.45,315.09,223.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.88,185c-.11,2.83-2.53,31.55-2.71,52-.08,8.75,3.18,21.92,3.18,21.92s-24.5-3.19-32.47-6.69c-4.63-2-16-12.34-16-12.34s8.55-35.22,14.57-48.94,18.1-41.1,27.11-43.59C352.56,147.42,359,181,358.88,185Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.88,185c-.11,2.83-2.53,31.55-2.71,52-.08,8.75,3.18,21.92,3.18,21.92s-24.5-3.19-32.47-6.69c-4.63-2-16-12.34-16-12.34s8.55-35.22,14.57-48.94,18.1-41.1,27.11-43.59C352.56,147.42,359,181,358.88,185Z",
    style: {
      fill: "#030402"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366,161.24c-3.91.3-10-8.26-11.83-13.33-.13-.35.7-2.47,1.75-6.53.63-2.47,1.27-5.23,1.68-7.79L373,140a41.35,41.35,0,0,0-3.11,9.59,5.56,5.56,0,0,0-.05,1.07,1,1,0,0,1,0,.17C369.88,152.92,369.76,161,366,161.24Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,153.38l.84.13c.07-1.13.08-2.09.08-2.64a1.08,1.08,0,0,1,0-.18,5.66,5.66,0,0,1,.05-1.07A41.19,41.19,0,0,1,373,140l-15.46-6.45c-.08.54-.17,1.07-.28,1.63C357.51,140.74,359.21,151.62,369,153.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,118.28c-2.09,5.66,0,22.47,3.85,26.42,5.62,5.73,15.32,6.81,20.3-.06,4.84-6.66,1.76-28.52-2.62-32.16C371.71,107.12,359.73,109.93,356.63,118.28Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.43,129.83s-.09.06-.08.11c.1,1.13,0,2.45-1,2.89a0,0,0,0,0,0,.07C372.63,132.64,372.71,130.89,372.43,129.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.34,128.7c-1.84,0-1.76,3.66-.06,3.68S372.88,128.73,371.34,128.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,129.74s.09,0,.09.1c0,1.14.16,2.45,1.2,2.81,0,0,0,.07,0,.06C379,132.56,378.8,130.82,379,129.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,128.53c1.83-.18,2.05,3.5.36,3.66S378.45,128.68,380,128.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.79,126.37a14.17,14.17,0,0,0,1.43-.49,2.55,2.55,0,0,0,1.37-.78.8.8,0,0,0-.12-.95,1.94,1.94,0,0,0-2-.21,2.82,2.82,0,0,0-1.64,1.21A.83.83,0,0,0,369.79,126.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.34,125.4a12.55,12.55,0,0,1-1.47-.35,2.44,2.44,0,0,1-1.44-.64.8.8,0,0,1,0-1,1.94,1.94,0,0,1,1.91-.4,2.81,2.81,0,0,1,1.76,1A.83.83,0,0,1,381.34,125.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.15,140c.28.26.56.62,1,.65a3.07,3.07,0,0,0,1.22-.32s.08,0,.05.06a1.53,1.53,0,0,1-1.43.65,1.22,1.22,0,0,1-.92-1C371,140,371.11,140,371.15,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,136.58a3.9,3.9,0,0,0,2.62,1.67,4.7,4.7,0,0,0,1.4,0,1.12,1.12,0,0,0,.27,0l.25-.05a.28.28,0,0,0,.22-.26h0a.41.41,0,0,0,0-.11h0v-.1c0-.88-.1-2.21-.1-2.21.32.15,2,.85,1.94.39a58.45,58.45,0,0,0-1.76-11.72.11.11,0,0,0-.21,0c.15,3.66.95,7.27,1.16,10.94a6.74,6.74,0,0,0-1.85-.52c-.12,0,.27,2.58.23,3v0a5.39,5.39,0,0,1-4.05-1.16C372.29,136.41,372.2,136.49,372.28,136.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.84,138.06a4.55,4.55,0,0,1-1.81,1.41,2.08,2.08,0,0,1-1.24.07c-.9-.23-.92-1-.75-1.76a4.8,4.8,0,0,1,.4-1.07A5.84,5.84,0,0,0,375.84,138.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,139.47a2.08,2.08,0,0,1-1.24.07c-.9-.23-.92-1-.75-1.76A2.1,2.1,0,0,1,374,139.47Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.71,119.32c-5.6,4.44-14.06-1.1-14.06-1.1a6.42,6.42,0,0,1-6.21,4.5s-.47,10-3.09,10.19c-4,.25-6.17-13.23-5.1-16s4.42-3.67,4.42-3.67a6.56,6.56,0,0,1,2.45-4.14c2.58-2.28,12.2-.12,12.2-.12a8.7,8.7,0,0,1,2.18-3.42,2.47,2.47,0,0,1,3.58.08,5.94,5.94,0,0,0-.79,2.52c-.27,2.94,2.11,2.78,1.91.14a4.1,4.1,0,0,0-1.12-2.66c1.06-1.81,2.93-2.5,4.16-1.66C384.47,105.52,386.36,115.63,381.71,119.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.66,119.61a.13.13,0,1,0-.24.08,25.52,25.52,0,0,1,1,6c0,2-.7,7.14-3.62,6.75a.11.11,0,0,0-.05.22c2,.78,3.1-1.75,3.61-3.49C362.28,126,361.65,122.64,360.66,119.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,103.87s0,0,0,0c3.32,3.66,4.44,9.12,1.93,13.57-3.15,5.6-10.52,2.65-14.93.66-.22-.1-.4.22-.18.32,4.3,2.07,11.77,4.86,15.11-.26C387,113.62,385.78,107.59,382.08,103.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.52,113.19c-3.9.69-6.58,2.74-6.68,6.92a15.21,15.21,0,0,0,4.91,11.23c.14.14.34-.07.21-.22a17.27,17.27,0,0,1-4.47-8.34c-.44-2.39-.34-5.1,1.22-7.1,1.12-1.43,3.19-1.9,4.85-2.35C358.66,113.31,358.61,113.17,358.52,113.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.55,109.75c-5.11-2.66-15-4.83-15.84,3.45,0,.06.11.08.12,0,1.3-8.32,10.44-5.26,15.63-3.24C373.59,110,373.66,109.81,373.55,109.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.58,132.55s-3.56-5.53-6.05-4.28,0,9.16,2.86,10.34a2.93,2.93,0,0,0,4-1.42Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.31,130.52c-.05,0-.06,0,0,.07,2,.89,3,2.8,3.64,4.76a1.62,1.62,0,0,0-2.4-.53s0,.12.05.11a1.79,1.79,0,0,1,1.95.7,8.3,8.3,0,0,1,.89,1.63c.09.19.41.1.35-.1v0C358.91,134.55,357.05,130.88,354.31,130.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.77,161.32c4.34,19.46,16.56,47.06,22.12,51.5,4.93,3.94,27.62,7,40.41,8.26,4.16.41,6.27-30.9,1.8-31.09-6.08-.27-28.45-2.22-29.49-3.18s-13.54-18.19-23.48-30.51C350.12,145.14,346.13,154,347.77,161.32Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.17,212.67a4.33,4.33,0,0,1-3.95,3,6.44,6.44,0,0,1-.3,4.36c-1.18,2.37-5.42,1.55-5.42,1.55a7.94,7.94,0,0,1-1.05,4.55c-1.36,2.15-5.74,1.93-5.74,1.93a7,7,0,0,1-3.44,3.42c-4.14,1.67-9.65-2.32-13.19-4.83s-11.2-12.92-12.86-14.76L405,190s11.1-1,20.63,1.49c6.26,1.62,11.76,6.48,13.25,7.89C442,202.31,447.1,209.42,446.17,212.67Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.32,215.18c-2.59-4-6.21-7-9.65-10.15-.08-.07-.19.05-.11.12,3.46,3.13,6.26,6.91,9.58,10.17C442.24,215.41,442.39,215.28,442.32,215.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.64,221.21a12.07,12.07,0,0,0-2.33-2.24q-1.32-1.09-2.67-2.16-2.7-2.12-5.51-4.1c-.09-.06-.2,0-.11.12,1.79,1.41,3.57,2.85,5.3,4.34.87.74,1.73,1.49,2.59,2.25a14.79,14.79,0,0,0,2.52,2A.16.16,0,0,0,436.64,221.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.63,228a8.38,8.38,0,0,0-2.2-1.9c-.83-.63-1.67-1.26-2.49-1.9-1.66-1.27-3.32-2.54-4.93-3.87-.08-.06-.19.05-.11.12,1.63,1.36,3.24,2.74,4.89,4.08.8.66,1.61,1.32,2.43,2a8.26,8.26,0,0,0,2.35,1.59A.06.06,0,0,0,429.63,228Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.67,211.71c8,8,39.77,11.21,39.77,11.21l-.69-34.87s-23.1-1.07-24-2c-1.93-1.92-15.09-22.05-25.51-32.65-8.76-8.9-12.41-1-9.46,11.25C351.3,179.36,364.85,208.89,367.67,211.71Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.67,211.71c8,8,39.77,11.21,39.77,11.21l-.69-34.87s-23.1-1.07-24-2c-1.93-1.92-15.09-22.05-25.51-32.65-8.76-8.9-12.41-1-9.46,11.25C351.3,179.36,364.85,208.89,367.67,211.71Z",
    style: {
      fill: "#030402",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,190.69c-.32,2.4-.19,12.08-.13,14.54s.68,12.2.83,14.63c0,.11.21.08.21,0,0-2.47-.33-26.79-.78-29.14C399.42,190.64,399.31,190.63,399.3,190.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.16,164.42c6.51,14.78,12.18,30.79,19.19,45.33-4.24-7.05-7.2-14.77-10.43-22.31s-6.07-15.26-8.76-23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.79,167.16c1.13,1.54,2.19,3.16,3.17,4.79a9.47,9.47,0,0,1-3.17-4.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.83,156a5.4,5.4,0,0,0,4.67-8.6,5,5,0,0,0,4.93-3.53,4.75,4.75,0,0,0-2.93-5.59s0,0,0,0a4.87,4.87,0,0,1,2.56,5.44,4.36,4.36,0,0,1-3.71,3.13,6,6,0,0,0,2.93-3.75,4.65,4.65,0,0,0-1.83-4.78,6.81,6.81,0,0,0,1.22-6,4.64,4.64,0,0,0-3.93-3.19,5.17,5.17,0,0,0-6.27-7.13,4.34,4.34,0,0,0-4.48-5.77,2.93,2.93,0,0,0-1.29-2.88,4.87,4.87,0,0,0-3.72-.52,3.49,3.49,0,0,0-2.62-2.09,3.17,3.17,0,0,0-3.46,2.21c-1.89-.9-4.06-1.6-6.12-1a4.52,4.52,0,0,0-3.36,3.72,6.28,6.28,0,0,0-8.09,4.77,4.41,4.41,0,0,0-3.84,2.16,6.42,6.42,0,0,0-1,3,3.33,3.33,0,0,0-3,2.45,4.36,4.36,0,0,0,.8,3.65,2.65,2.65,0,0,1-.22,1.09,5.74,5.74,0,0,0,.38,5.41,3.92,3.92,0,0,0,.84,5.82,4.41,4.41,0,0,0,2.28,5.74,6.41,6.41,0,0,0,.57,5.3,3.71,3.71,0,0,0,3.54,2,2.23,2.23,0,0,0,1.75,2.42,5.16,5.16,0,0,0,1.23.19,4.91,4.91,0,0,1,1.58.14c.48.21.72.76,1,1.13a5.26,5.26,0,0,0,.78.71,5.81,5.81,0,0,0,7.28-.41c1.26,1.43,3.34,1.43,5.06.87a9.21,9.21,0,0,0,1.6-.72,2.54,2.54,0,0,1,1.49-.4c.35,0,.68.14,1,.17a4,4,0,0,0,3-1.23C193,163.67,198.42,160.67,198.83,156Zm-43.07-27.21a3.49,3.49,0,0,1,2.68-3V126s-.42.24-.61.38a4.85,4.85,0,0,0-.9.91,4.59,4.59,0,0,0-.89,2.49,4.68,4.68,0,0,0,.12,1.18c0,.05,0,.1,0,.15A4.2,4.2,0,0,1,155.76,128.81Zm29.05-16.92a3.34,3.34,0,0,0-3.63,1.25l-.11,0c.66-1.29,1.61-2.28,3.25-2a2.93,2.93,0,0,1,2.24,1.88h0A3.75,3.75,0,0,0,184.81,111.89Zm4.82,48,0,0a6,6,0,0,0,8.21-1.92C196.21,161,193,162.64,189.63,159.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.82,159.28c-24.57,4.6-48.72,13.1-51.59,20.19-3.87,9.54.68,27.62,2.92,40.1.65,3.66,29.07-2,28.38-5.95-.85-4.73-8.08-23-8-23.5.13-1,23.77-17.41,29.51-21.19C172.6,162.62,172.72,157.23,161.82,159.28Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.46,238.11c-3.06-5.38-5-18.84-4.22-22.27s23.56-7.49,26.23-5.07S151,232.13,150,238.37,120.62,243.7,117.46,238.11Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.64,228.46c-2.86-1.6-3.12,2.69-3.12,2.69s-1.12-6.27-4.71-6.78-3.59,4.71-3.6,5.08c-.06-.33-1.25-6.06-4.91-6.2s-3,5.09-3,5.43c-.16-.3-2.3-4.15-5.1-3.63-4.83.9.38,10.9-1,14.64,0,0-6.59-1.57-6.79-1.58,0,0,4.75,9.62,9.89,11.16a3.43,3.43,0,0,0,4-1.55s1.2,3.27,4.08,3.47c1.47.11,2.95-2.17,2.95-2.17a4.29,4.29,0,0,0,3.64,2.6c2,0,3.21-2.26,3.21-2.26s2.17,2,4.27,1.34C153.75,249.39,155.77,231.9,149.64,228.46Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,249a0,0,0,0,0,.09,0,30.52,30.52,0,0,0,1-18.13c-.05-.19-.38-.19-.36,0A62.64,62.64,0,0,1,145.47,249Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.41,249.11c0,.07.09.09.12,0a28.66,28.66,0,0,0-.13-19.85c-.1-.22-.4-.33-.31-.06C139.52,233.63,139.54,243.54,138.41,249.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,228.29c2.3,6.27,2.36,12.64,1.48,19.2,0,.08.11.09.14,0,1.3-3.09,1.43-7.32,1.25-10.63a17.66,17.66,0,0,0-2.65-8.67C130.14,228.11,129.93,228.16,130,228.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.52,231.15a19.66,19.66,0,0,0-1.29-3.43A6.82,6.82,0,0,0,143,225a2.25,2.25,0,0,0-1.55-.33,3.3,3.3,0,0,0-1.48.68,3.91,3.91,0,0,0-1.21,3l0,2.69-.91-2.54a10.8,10.8,0,0,0-1.7-3.13,3.9,3.9,0,0,0-2.75-1.67,2.23,2.23,0,0,0-2.39,1.52,6.83,6.83,0,0,0-.17,3.4l.54,3.15-1.53-2.78a10.16,10.16,0,0,0-1.55-2.14,4.26,4.26,0,0,0-2.09-1.3,2,2,0,0,0-2,.69,4.42,4.42,0,0,0-.62,2.43,34.55,34.55,0,0,0,.52,5.5c.12.92.25,1.85.34,2.79a6.73,6.73,0,0,1-.18,2.79,7.13,7.13,0,0,0-.08-2.76c-.15-.92-.35-1.83-.55-2.74a30.26,30.26,0,0,1-.82-5.59,5.22,5.22,0,0,1,.66-2.93,2.87,2.87,0,0,1,2.94-1.15,5.32,5.32,0,0,1,2.63,1.56,11.36,11.36,0,0,1,1.76,2.35l-1,.36a7.79,7.79,0,0,1,.16-4,3.22,3.22,0,0,1,1.38-1.72,3.64,3.64,0,0,1,2.12-.48,5,5,0,0,1,3.49,2.11,11.81,11.81,0,0,1,1.82,3.48l-.94.15a4.69,4.69,0,0,1,1.69-3.58,4,4,0,0,1,1.87-.74,2.85,2.85,0,0,1,2,.51,6.76,6.76,0,0,1,2.17,3.09A15.93,15.93,0,0,1,146.52,231.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.55,213.73s20.91,15.91,10.69,21c-3,1.52-17.33,4.15-17.91,1.29-.76-3.69,5-5.9,8.84-6.72,0,0-7.87-4.41-6.44-10.81A6.51,6.51,0,0,1,141.55,213.73Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.06,234.29a13.6,13.6,0,0,1-3.62,1.69,29.32,29.32,0,0,1-3.9,1,45.37,45.37,0,0,1-8,.89,7.53,7.53,0,0,1-2.12-.25,2.93,2.93,0,0,1-1.08-.58,2,2,0,0,1-.43-.51,1.79,1.79,0,0,1-.23-.63,3.38,3.38,0,0,1,.39-2.31,6.21,6.21,0,0,1,1.44-1.65,12.39,12.39,0,0,1,3.66-2,27,27,0,0,1,3.91-1.07l-.12.86a16.18,16.18,0,0,1-2.47-1.84,14.7,14.7,0,0,1-2.06-2.26A10.41,10.41,0,0,1,137,223a7.8,7.8,0,0,1-.44-3,9,9,0,0,0,.74,2.86,10.75,10.75,0,0,0,1.58,2.46,14.92,14.92,0,0,0,2.09,2,15.58,15.58,0,0,0,2.42,1.6l1.06.56-1.18.31a29.45,29.45,0,0,0-3.74,1.15,12,12,0,0,0-3.32,1.83,3.32,3.32,0,0,0-1.46,2.88c.12.9,1.56,1.12,2.81,1.15s2.61-.05,3.92-.14,2.64-.21,4-.38A25.83,25.83,0,0,0,153.06,234.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31,187.48l-17.75-21.63s23.12-6.64,37.51-8.36,17.2,5.17,6.57,13.72S139.31,187.48,139.31,187.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31,183.08c-.62-.72-1.13-1.55-1.69-2.31s-1.15-1.53-1.74-2.28q-1.71-2.19-3.39-4.38c-2.28-3-4.49-6-7-8.83,0-.05-.12,0-.09.05a87.23,87.23,0,0,0,6.42,9.12q1.73,2.22,3.51,4.41c.61.73,1.23,1.47,1.87,2.18s1.36,1.39,1.95,2.12C143.25,183.22,143.36,183.14,143.31,183.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.57,397.78S93.89,434.9,93.89,434.93c-1.43,8.08-.44,20.22-.19,20.45,0,0,0,.05,0,.06,2.47,1.63,68.42,2.88,70.74,2.15s.41-7.39-2.11-9.48-27.57-13.86-27.57-13.86l21.41-35.73Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.48,457.59c-2.31.72-68.25-.51-70.73-2.16l0-.05c-.25-.23-1.23-12.38.19-20.45l3.27-6.19,40.31,1.08-2.66,4.43s25,11.77,27.57,13.86S166.81,456.87,164.48,457.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,457.86c-2.34.73-68.92-.72-71.42-2.37-1-.63-1-10,0-22.08l41.53.81s25.25,11.95,27.8,14.07S167.16,457.14,164.81,457.86Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.92,455.18c-11.16-.52-56.2-1.55-67.26-1.21-.09,0-.1.06,0,.07,11,.75,56.1,1.42,67.26,1.32C164.15,455.36,164.15,455.19,163.92,455.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.48,445.8a8.94,8.94,0,0,0-6.74,2.58,8.67,8.67,0,0,0-2.62,5.9c0,.07.12.08.13,0a10.35,10.35,0,0,1,9.22-8.35C158.56,445.93,158.57,445.8,158.48,445.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.22,435.42c-4.47-.16-9.68,1.31-12.54,4.9-.11.14.09.29.23.23A61.66,61.66,0,0,1,139.28,436,.28.28,0,0,0,139.22,435.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.64,436.84c-4.47-.16-9.68,1.3-12.54,4.9-.11.14.09.29.23.23a61.66,61.66,0,0,1,12.37-4.58A.28.28,0,0,0,142.64,436.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,438.26c-4.47-.16-9.68,1.3-12.54,4.9-.11.14.09.29.22.23a61.37,61.37,0,0,1,12.38-4.58A.28.28,0,0,0,146.06,438.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48,439.68c-4.47-.16-9.68,1.3-12.54,4.9-.11.14.09.29.22.23a61.37,61.37,0,0,1,12.38-4.58A.28.28,0,0,0,149.48,439.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.73,443.43c-5-.09-5.17,7.7-.15,7.79S104.75,443.53,99.73,443.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.3,423.61c-2.22-1.93-5.11-.16-6.54,1.76a23.37,23.37,0,0,0-4.31,11.33c0,.1.06.14.14.13a.54.54,0,0,0,.79.38c3.23-2.13,7-4,9.43-7.06C145.25,428.36,146.4,425.42,144.3,423.61ZM138.62,433c-1.57,1.09-3.17,2.09-4.69,3.23a68.72,68.72,0,0,1,2.66-6.56,25.13,25.13,0,0,1,1.7-3c1-1.45,5.46-5.09,5.8-.22C144.28,429.13,140.48,431.69,138.62,433Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.32,438.12c3.87.68,7.91-.34,11.74-.85a.55.55,0,0,0,.36-.81.12.12,0,0,0,0-.19,23.37,23.37,0,0,0-10.68-5.72c-2.35-.51-5.69.05-6.1,3C117.26,436.26,120.05,437.72,122.32,438.12Zm-2.65-2.6c-2.93-3.9,2.82-4.08,4.53-3.64a24.85,24.85,0,0,1,3.24,1.13,69.2,69.2,0,0,1,6.31,3.21c-1.9.13-3.77.43-5.66.63C125.84,437.1,121.29,437.67,119.67,435.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.74,424.79,141.21,430s64-102.43,63.75-133.08c-.15-15.85-46.65-65.56-46.65-65.56l-.56-21.8H123.21s-15.58,28.37-9.77,42.95c6,15,38.61,47.35,40.11,52C155.53,310.5,92.74,424.79,92.74,424.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.39,415.56a35.49,35.49,0,0,1,4,.16c1.48.07,3,.14,4.43.25,2.83.22,5.66.51,8.49.84,5.69.66,11.38,1.39,17.06,2.26,3.22.49,6.44,1,9.66,1.58.12,0,.09.22,0,.2-5.67-.47-11.33-1.06-17-1.63s-11.33-1.14-17-1.93c-1.61-.23-3.23-.44-4.84-.72s-3.27-.4-4.82-.82C100.29,415.72,100.27,415.56,100.39,415.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,296.89c.11,13-11.3,38.83-24.51,64.33L123.21,209.53h34.54l.56,21.79S204.81,281,205,296.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.82,396.66S165.69,440,165.69,440c.32,8.24.27,19.55,1.84,20.86,2.51,1.57,68.71,1.93,71,1.14s.21-7.39-2.37-9.41-27.94-13.09-27.94-13.09l3.72-43.28Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.53,462c-2.29.8-68.48.43-71-1.14C166,459.55,166,448.24,165.69,440c0,0,.22-2.36.57-5.95h42.43l-.47,5.45s25.34,11.07,27.94,13.09S240.83,461.22,238.53,462Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.73,462.23c-2.33.77-68.92.54-71.46-1.07-1-.61-1.5-10.31-1.81-22.05l42.94,0s25.46,11.49,28,13.56S241.06,461.46,238.73,462.23Z",
    style: {
      fill: "#FF6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.78,459.56c-11.16-.31-56.21-.52-67.27,0-.09,0-.09.07,0,.07,11.06.55,56.11.39,67.27.09C238,459.74,238,459.57,237.78,459.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.17,450.28a9,9,0,0,0-6.69,2.7,8.71,8.71,0,0,0-2.51,6c0,.06.12.06.13,0a10.38,10.38,0,0,1,9.07-8.52A.07.07,0,0,0,232.17,450.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.73,440.26c-4.47-.08-9.66,1.48-12.45,5.12-.11.14.1.3.23.23a61.45,61.45,0,0,1,12.29-4.8A.28.28,0,0,0,212.73,440.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.17,441.61c-4.47-.07-9.65,1.49-12.44,5.13-.11.14.09.29.22.22a62.77,62.77,0,0,1,12.3-4.8A.28.28,0,0,0,216.17,441.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.61,443c-4.46-.08-9.65,1.48-12.44,5.13-.11.14.1.29.23.22a61.45,61.45,0,0,1,12.29-4.8A.28.28,0,0,0,219.61,443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.06,444.33c-4.47-.08-9.65,1.48-12.44,5.12-.11.14.09.3.22.23a61.69,61.69,0,0,1,12.29-4.8A.28.28,0,0,0,223.06,444.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.39,449c-5,0-5,7.79,0,7.79S178.41,449,173.39,449Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.59,428.35c-2.25-1.88-5.11-.06-6.51,1.88a23.52,23.52,0,0,0-4.1,11.41.12.12,0,0,0,.14.13.55.55,0,0,0,.8.37c3.19-2.19,6.87-4.14,9.3-7.24C218.63,433.09,219.73,430.13,217.59,428.35Zm-5.51,9.48c-1.54,1.11-3.13,2.15-4.63,3.32.81-2.23,1.51-4.47,2.54-6.62a25.59,25.59,0,0,1,1.64-3c1-1.48,5.38-5.2,5.81-.33C217.67,433.88,213.92,436.5,212.08,437.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.88,443.26c3.89.61,7.9-.48,11.73-1.06a.54.54,0,0,0,.33-.81c.06-.05.09-.13,0-.19a23.46,23.46,0,0,0-10.79-5.53c-2.35-.46-5.68.16-6,3.07C190.79,441.5,193.61,442.91,195.88,443.26Zm-2.69-2.55c-3-3.84,2.74-4.13,4.46-3.72a24.71,24.71,0,0,1,3.25,1.07,70.74,70.74,0,0,1,6.38,3.09c-1.9.17-3.76.5-5.65.74C199.38,442.18,194.85,442.83,193.19,440.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07,257.34s32.48,62.39,33.46,67.05C177,331.59,162,433.24,162,433.24l51.88.31s13.08-97,9.92-116.12c-2.81-17-44.63-85.62-46.27-89.5-2-4.68-3.27-12.19-4.1-18.41h-49s-2.33,25.27,9.16,43.54C133.53,253.06,138.73,255.46,142.07,257.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.71,423.67c6-.17,12.21-.35,18.2-.2s11.91.24,17.84.59c3.37.2,6.73.32,10.09.65a.09.09,0,0,1,0,.18c-6,.35-12,.28-18,.22s-11.9-.11-17.85-.39c-3.37-.15-6.73-.32-10.09-.55C164.54,424.14,164.35,423.68,164.71,423.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.9,258.58a46.33,46.33,0,0,1-7.71-.69c-2.57-.49-5-1.34-7.46-2.07a58.17,58.17,0,0,0-7.32-1.2,25.64,25.64,0,0,1-7.18-2.14c-.1,0-.19.11-.09.16a43.59,43.59,0,0,0,6.88,3c2.46.78,5,.89,7.53,1.5a63.27,63.27,0,0,0,7.68,1.77,28.29,28.29,0,0,0,7.69-.13C155,258.74,155,258.59,154.9,258.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07,257.34c11.06,20.82,21.92,41.77,32.17,63,.58,1.29,1.19,2.46,1.71,3.88.4,2.86-.08,5.62-.25,8.46-.49,5.54-1.19,11-1.89,16.55q-2.12,16.51-4.71,33c1.39-11,2.76-22,4-33,.63-5.51,1.21-11,1.7-16.55a44.4,44.4,0,0,0,.24-8.14c-.45-1.18-1.1-2.48-1.68-3.72-9.36-19-22.2-44.5-31.33-63.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.8,248c.08-3.29.33-13.7.4-15.61,0-1,.35-6.46.73-6.46a49.07,49.07,0,0,1,5.9.66q2.88.33,5.78.55,5.87.43,11.77.41a.41.41,0,1,1,0,.82q-6,.1-11.91-.25c-1.93-.12-9.39-.7-11.09-1.11-.06.78,0,3.7,0,4.35.82.08,1.63.32,2.43.48s1.81.34,2.72.48q2.82.43,5.69.68a88.91,88.91,0,0,0,11.07.25c.12,0,.11.15,0,.16a64.22,64.22,0,0,1-11.35.09c-1.77-.15-3.53-.37-5.28-.65-1-.16-1.9-.34-2.85-.53a18.28,18.28,0,0,1-2.43-.58v.39c0,1.82-.2,12.53-.24,16.06,1.83,1.15,10.79,6.77,12,6.31,2.27-.88,10.2-4.81,12.48-5.73.11-3.16.12-6.33,0-9.49-.07-1.63-.17-3.26-.29-4.88a29.76,29.76,0,0,1-.26-5c0-.13.23-.22.31-.08l.12.22a.11.11,0,0,1,0,.11,22.78,22.78,0,0,1,.81,4.48c.2,1.66.35,3.33.47,5,.24,3.34.31,6.69.24,10a.61.61,0,0,1-.34.55c-3.45,1.45-13,6-13.8,6-1.59.08-12.55-6.47-12.83-6.72S144.79,248.36,144.8,248Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61,243.7c.63-2.76,2.6-11.48,2.95-13.09.18-.8,1.12-5.44.91-5.48a18.14,18.14,0,0,0-3.39-.16c-1.11-.05-2.21-.13-3.3-.25a55.69,55.69,0,0,1-6.58-1.07c-.33-.08-.49.61-.17.69a61.67,61.67,0,0,0,6.62,1.22A49.14,49.14,0,0,0,135,226c-.12.66-.77,3.09-.9,3.63a11.63,11.63,0,0,0-1.44.11c-.54,0-1.07.06-1.6.07a29.79,29.79,0,0,1-3.28-.12,32.76,32.76,0,0,1-6.16-1.12c-.07,0-.1.11,0,.13a23.88,23.88,0,0,0,6.25,1.45,25.83,25.83,0,0,0,3,.09c.56,0,1.12-.05,1.68-.1a6.64,6.64,0,0,0,1.46-.19c0,.11-.05.22-.08.32-.36,1.53-2.44,10.49-3.13,13.45-1.24.74-7.33,4.35-7.9,3.82-1.08-1-4.66-5.24-5.73-6.29.58-2.65,1.22-5.3,1.94-7.93.36-1.35.75-2.7,1.15-4a40.19,40.19,0,0,0,1.15-4.13c0-.12-.08-.22-.15-.1l-.11.16a.15.15,0,0,0,0,.09,30,30,0,0,0-1.36,3.65c-.44,1.36-.87,2.74-1.27,4.12-.81,2.76-1.53,5.55-2.17,8.35a.57.57,0,0,0,.08.5c1.6,1.63,6,6.55,6.39,6.69.86.26,8.25-3.89,8.45-4.06A1.31,1.31,0,0,0,131.61,243.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,238c.71-4.84,1.45-9.67,2.39-14.47.54-2.76,1.11-5.52,1.74-8.26,0-.1.18-.09.17,0-.87,4.85-1.73,9.7-2.54,14.56s-1.45,9.66-2.14,14.5c-.39,2.79-.76,5.57-1.15,8.36,0,.1-.17.08-.16,0C136.13,247.73,136.73,242.84,137.45,238Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.83,160.32c-.19,1.09,1.82,9.49,6.43,11.18,1.5.54,4.85-7.51,4.85-7.51l.39-.54,5.36-7.54-7.13-10.38-1.06-1.43s-1.33,2.16-3,4.86l-.24.39c-.09.15-.19.29-.27.44-.25.4-.5.81-.74,1.22s-.37.62-.56,1l-.56,1A58.39,58.39,0,0,0,165.83,160.32Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.71,149a18.53,18.53,0,0,0,5.79,14.49l5.36-7.54-7.13-10.38-1.06-1.43S173.34,146.26,171.71,149Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18,144.26c-.65,16.22-10.4,17.83-13.93,17.52-3.17-.27-14-1-15-17.18s6.71-21,14-21.11S200.83,128,200.18,144.26Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,140.66c-.38-.09-.71-.23-1.07-.35a1.83,1.83,0,0,1-1-.57.59.59,0,0,1,.08-.7,1.45,1.45,0,0,1,1.44-.18,2.1,2.1,0,0,1,1.23.89A.61.61,0,0,1,198.8,140.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.54,141.66a10.22,10.22,0,0,0,1.08.31,1.85,1.85,0,0,0,1.16.1.56.56,0,0,0,.32-.62,1.43,1.43,0,0,0-1.09-1,2.12,2.12,0,0,0-1.51,0A.62.62,0,0,0,187.54,141.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.87,144.28c0-.05-.09,0-.1.09-.06,1.1-.31,2.36-1.34,2.64,0,0,0,.06,0,.06C189.67,147,190,145.33,189.87,144.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,143c-1.75-.29-2.2,3.25-.57,3.52S190.46,143.28,189,143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.27,143.14c-.34.16-.69.48-1.06.47s-.72-.43-1-.82c0,0-.06,0-.06,0a1.29,1.29,0,0,0,.79,1.59c.65.18,1.2-.36,1.46-1C188.49,143.28,188.4,143.08,188.27,143.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.23,144.45s.07.06.07.1c-.19,1.09-.21,2.37.73,2.87,0,0,0,.07,0,.06C195.83,147.15,195.88,145.45,196.23,144.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.36,143.43c1.78.1,1.44,3.66-.21,3.56S195.86,143.35,197.36,143.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08,143.74c.26.21.5.58.84.63s.71-.29,1-.64c0,0,.05,0,.05.05,0,.68-.34,1.36-1,1.43s-1-.56-1.09-1.25C197.86,143.83,198,143.65,198.08,143.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.78,152.74c.22.3.42.7.81.8a3,3,0,0,0,1.22-.07,0,0,0,0,1,0,.06,1.49,1.49,0,0,1-1.48.36,1.18,1.18,0,0,1-.69-1.12C188.66,152.71,188.75,152.7,188.78,152.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,149.3s0,1.66-.05,2.44c0,.07-.2.08-.47.07h0a3.71,3.71,0,0,1-3.41-1.79c-.05-.08.06-.15.13-.09a5.52,5.52,0,0,0,3.24,1.35c.08-.21-.16-2.86,0-2.85a6.62,6.62,0,0,1,1.71.6c0-3.48-.52-6.92-.45-10.38a.11.11,0,0,1,.21,0,56,56,0,0,1,.95,11.16C195.65,150.23,194.12,149.46,193.83,149.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.16,127.54a7.25,7.25,0,0,1-.85,4.13c-2.27,3.32-6.42,1.69-8.12,2.88s-1.53,3.94-3,5.08c-2,1.57-4.26.48-4.74,1.68s-1.91,5-3.57,5.26-4.74-27.14,15.68-23.07c0,0,3-.71,7,2.2,4.45,3.2,5.3,11.52,5.3,11.52s-.09-.13-.69-.86c-.86-1-1.11-1.91-1.75-2.6-1-1.07-1.68-.83-2.73-1.89A13.74,13.74,0,0,1,192.16,127.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,126.35a14.15,14.15,0,0,1,.11,3.25,5.92,5.92,0,0,1-.92,3,4.3,4.3,0,0,1-2.65,1.47c-1,.21-2.13.14-3.25.4a3.31,3.31,0,0,0-1.54.82,4.43,4.43,0,0,0-.85,1.5,5.9,5.9,0,0,1-1.59,2.68,3.6,3.6,0,0,1-2.94.72c-1-.16-2.13-.63-3.22-.33,1.11-.21,2.11.33,3.17.58a3.9,3.9,0,0,0,3.23-.66,5.82,5.82,0,0,0,1.78-2.82,3.9,3.9,0,0,1,.77-1.32,2.81,2.81,0,0,1,1.32-.67c1-.25,2.11-.2,3.21-.43a5.73,5.73,0,0,0,1.59-.58,3.34,3.34,0,0,0,1.29-1.13,6.14,6.14,0,0,0,.85-3.22A14.23,14.23,0,0,0,192,126.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.27,127.35a11.42,11.42,0,0,0,.55,3,5.39,5.39,0,0,0,1.7,2.61,7.74,7.74,0,0,0,1.34.78,2.45,2.45,0,0,1,1,.92,8,8,0,0,0,.7,1.36,3.27,3.27,0,0,0,1.19,1,3.83,3.83,0,0,1-1-1.11,8.39,8.39,0,0,1-.55-1.39,2.62,2.62,0,0,0-1.11-1.17,8.75,8.75,0,0,1-1.26-.76,5.76,5.76,0,0,1-1.63-2.35A22.78,22.78,0,0,1,192.27,127.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.07,145.16s-3.58-5-5.87-3.76.42,8.6,3.13,9.59a2.75,2.75,0,0,0,3.67-1.5Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,143.48c-.05,0-.05.06,0,.07,1.9.75,2.91,2.5,3.62,4.32a1.51,1.51,0,0,0-2.27-.4c-.05,0,0,.11,0,.1a1.68,1.68,0,0,1,1.86.58,7.3,7.3,0,0,1,.9,1.49c.09.17.4.08.33-.12,0,0,0,0,0,0C174.52,147.07,172.62,143.7,170,143.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.88,210.33,174,225.47l-56.19-10.12s20.87-44.17,39.68-54.75c9.41-5.29,17.39-2.07,20.88,4.9.88,1.77,9.68,23.77,8.76,32.24C186.32,205.21,178.88,210.33,178.88,210.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.11,161.15l-13.35-2.4c.37-.12.74-.22,1.1-.32l11.41,2.06C174.56,160.69,174.83,160.92,175.11,161.15Zm2.68,3.25-20.46-3.69c-.22.12-.44.25-.66.4L178.1,165C178,164.78,177.9,164.59,177.79,164.4Zm1.65,3.57-25.9-4.66c-.18.14-.36.27-.54.43l26.67,4.79Zm1.37,3.53L150.38,166l-.45.43L181,172.05Zm1.26,3.51-34.47-6.2c-.14.14-.26.29-.4.43l35.06,6.32C182.2,175.37,182.14,175.19,182.07,175Zm1.19,3.49-38.2-6.88-.39.46,38.77,7C183.39,178.86,183.32,178.68,183.26,178.5Zm1.1,3.49-41.67-7.5-.35.44,42.17,7.59C184.47,182.35,184.41,182.16,184.36,182Zm1,3.45-44.87-8.08-.35.45L185.49,186Zm.85,3.43-47.86-8.61-.32.46,48.3,8.69C186.28,189.24,186.23,189.05,186.19,188.87Zm.66,3.41-50.56-9.1-.31.45,51,9.17C186.91,192.63,186.88,192.45,186.85,192.28Zm.36,3.34-52.88-9.52c-.09.15-.2.31-.3.46l53.19,9.57C187.23,196,187.21,195.79,187.21,195.62ZM132.44,189c-.1.16-.21.31-.3.47l54.73,9.84a3.67,3.67,0,0,0,.11-.5Zm-1.84,3-.28.47,55.41,10A3.92,3.92,0,0,0,186,202Zm-1.77,3c-.1.15-.2.31-.28.46l55.36,10c.1-.16.22-.31.33-.46Zm-1.74,3c-.1.17-.19.32-.27.48l54.57,9.82.45-.44Zm-1.7,3-.26.46L178.67,211l.16-.49Zm-1.64,3c-.09.15-.17.31-.26.47l54.18,9.75.16-.49Zm-1.61,3c-.09.16-.17.32-.26.47l54.8,9.86.16-.49Zm-1.56,3-.25.47,55.36,10,.15-.48Zm-1.53,3c-.08.17-.16.33-.24.47L174.7,223.4l.14-.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,170.71c-3.74,10-10.36,41.49-6.09,50.69s29,24.68,37.59,29.91c2.74,1.65,15.88-24.61,10.27-27.2-7.24-3.34-21.36-13-24.26-16-2-2.07-2.81-22.2-4.3-37.11C176.93,158.55,169.7,158.09,165,170.71Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,258.53a4.34,4.34,0,0,1-4.7,1.54,6.4,6.4,0,0,1-1.7,4c-1.88,1.86-5.62-.28-5.62-.28a8,8,0,0,1-2.47,4c-2,1.6-6.06,0-6.06,0a6.93,6.93,0,0,1-4.36,2.12c-4.46.25-8.38-5.32-10.91-8.83s-6.42-15.86-7.4-18.13l11.62-19.2s10.82,2.67,19,8.09c5.4,3.56,9,9.94,10,11.75C236.08,247.38,238.58,255.75,236.65,258.53Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.19,259.65c-1.16-4.6-3.61-8.59-5.84-12.73a.08.08,0,0,0-.14.08c2.26,4.09,3.68,8.56,5.77,12.73C232,259.84,232.23,259.77,232.19,259.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.87,263.52a12.59,12.59,0,0,0-1.48-2.87c-.59-1-1.2-1.95-1.82-2.91q-1.87-2.88-3.9-5.66c-.06-.09-.2,0-.14.08,1.24,1.91,2.46,3.85,3.62,5.81.58,1,1.15,2,1.72,3a14.59,14.59,0,0,0,1.72,2.73A.17.17,0,0,0,224.87,263.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.05,267.66a8.49,8.49,0,0,0-1.47-2.51l-1.75-2.6c-1.15-1.74-2.31-3.48-3.4-5.26-.06-.09-.2,0-.14.08,1.1,1.81,2.18,3.64,3.3,5.44.54.89,1.1,1.77,1.66,2.65a7.94,7.94,0,0,0,1.71,2.26A.06.06,0,0,0,216.05,267.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,201.36l-27.27,6.22s4.38-23.65,9.25-37.29,12.31-13.09,15.21.24S182,201.36,182,201.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.87,195.81c-.93.23-1.9.32-2.83.48s-1.88.35-2.81.54l-5.43,1.08c-3.68.72-7.36,1.35-11,2.28-.06,0,0,.11,0,.11a86.74,86.74,0,0,0,11-1.69q2.76-.54,5.51-1.17c.93-.22,1.87-.44,2.79-.7s1.85-.6,2.77-.8C180,195.92,180,195.79,179.87,195.81Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.27,97.21A25.87,25.87,0,0,0,333.56,118l12.68,3.23L341,109.42a25.88,25.88,0,1,0-48.69-12.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.27,97.21c.42,21.6,24.08,32.94,41.38,20.43l12.7,3.16-.51.6-5.32-11.79-.09-.21c8-14.37-.11-33-16.06-37-16-4.37-32.19,8.27-32.1,24.81Zm0,0c.06-22,25.76-34.09,42.78-20.07,9.4,7.6,12.29,21.91,6.34,32.51v-.43L346.64,121l.37.84-.88-.23-12.66-3.32c-16.14,12.27-41.08.75-41.2-21.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.25 113.76 302.65 102.02 306.55 98.17 313.32 105.03 327.4 82.96 332.02 85.91 314.25 113.76",
    style: {
      fill: "#FF6200"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d35bce99c07024b59a188e9491d08bd9.svg";
export { ForwardRef as ReactComponent };